export var dropZeros = function (value, decimalPoints) {
    if (decimalPoints === void 0) { decimalPoints = 2; }
    return parseFloat(value.toFixed(decimalPoints));
};
var MAX_ITERATIONS = 200;
var ERROR = 0.01;
var MAX_DEN = 8;
var DEN_TO_SKIP = 7;
// https://stackoverflow.com/questions/5124743/algorithm-for-simplifying-decimal-to-fractions/5128558#5128558
export var getFractions = function (value) {
    var int = Math.floor(value);
    var valueWithoutInt = value - int;
    if (valueWithoutInt < ERROR) {
        return [int, 0, 1];
    }
    else if (1 - ERROR < valueWithoutInt) {
        return [int + 1, 0, 1];
    }
    var lowerNum = 0;
    var lowerDen = 1;
    var upperNum = 1;
    var upperDen = 1;
    for (var i = 0; i < MAX_ITERATIONS; i++) {
        var middleNum = lowerNum + upperNum;
        var middleDen = lowerDen + upperDen;
        if (middleDen > MAX_DEN) {
            break;
        }
        if (middleDen * (valueWithoutInt + ERROR) < middleNum) {
            upperNum = middleNum;
            upperDen = middleDen;
        }
        else if (middleDen * (valueWithoutInt - ERROR) > middleNum) {
            lowerNum = middleNum;
            lowerDen = middleDen;
        }
        else {
            break;
        }
    }
    var resultDen = lowerDen + upperDen;
    if (resultDen > MAX_DEN || resultDen === DEN_TO_SKIP) {
        return;
    }
    return [int, lowerNum + upperNum, resultDen];
};
//# sourceMappingURL=number.js.map